import app from 'flarum/forum/app';
import { override } from 'flarum/common/extend';
// Server errors a moment's wait may clear: the server overloaded (500 when
// MySQL refuses a connection, 503 when php-fpm has no worker left) or a
// proxy timing out.
const RETRIED_STATUSES = [500, 502, 503, 504];

/**
 * Retries a read (GET) once, a second or two later, when the server failed
 * it - instead of core's "Oups, une erreur est survenue. Veuillez actualiser
 * la page et réessayer." at once. An overloaded server fails some of a
 * page's parallel requests and lets the next try through: reported
 * 2026-10-31 from a species page reached from an exhibition's public page,
 * one alert for each of its ~8 requests (the species, its gallery,
 * descriptions, keys, synonyms, children, discussions), while bots kept
 * MySQL at its max_user_connections. A second failure is reported as usual.
 *
 * Only reads: safe to repeat. The wait is spread over 1-2 s, so a page's
 * retries don't all land at once on a server already struggling. Writes
 * have their own retry for a stale CSRF token (retryOnStaleCsrfToken.ts).
 */
export default function retryFailedReads() {
  override(app, 'request', function (original, options) {
    if ((options.method || 'GET').toUpperCase() !== 'GET') return original(options);
    let failed = false;
    const errorHandler = options.errorHandler;
    return original({
      ...options,
      // Keeps a server error quiet - it is about to be retried - and hands
      // every other one on unchanged (false = core's default handler, what a
      // request without its own errorHandler gets).
      errorHandler: error => {
        if (RETRIED_STATUSES.includes(error.status)) {
          failed = true;
          return;
        }
        return errorHandler ? errorHandler(error) : false;
      }
    }).catch(async error => {
      if (!failed) throw error;
      await new Promise(resolve => setTimeout(resolve, 1000 + Math.random() * 1000));

      // With its own errorHandler again: a second failure is reported as usual.
      return original(options);
    });
  });
}